import { Icon } from 'bold-ui'
import React from 'react'

import { AccordionDataTableRowDefaultProps } from './AccordionDataTableRowDefault'

interface AccordionDataTableRowIconProps<T> extends Pick<AccordionDataTableRowDefaultProps<T>, 'disabled'> {}

export function AccordionDataTableRowIcon<T>(props: Readonly<AccordionDataTableRowIconProps<T>>) {
  const { disabled } = props

  return (
    <Icon
      name='accordionAngleIcon'
      icon={!disabled ? 'angleDown' : 'angleUp'}
      fill={!disabled ? 'secondary' : 'disabled'}
    />
  )
}
